<template>
  <Card>
    <span slot="title">医生档案</span>
    <el-button slot="btn" icon="el-icon-refresh" @click="$refresh(getDoctorsList)">刷新</el-button>
    <div slot="content" class="doctorwrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="姓名">
            <el-select allow-create clearable v-model="searchForm.doctorName" placeholder="请选择医生" filterable
              default-first-option>
              <el-option v-for="item in doctorOptions" :key="item.value" :label="item.label" :value="item.label">
                <span class="fl">{{ item.label }}</span>
                <span class="select-flex">{{ item.phone }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="职称">
            <el-select v-model="searchForm.doctorTitle" filterable default-first-option clearable placeholder="请选择医生职称">
              <el-option v-for="item in doctorTitlesOptions" :key="item" :label="item" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="searchForm.status" filterable default-first-option placeholder="请选择医生状态">
              <el-option
                v-for="item in [{ label: '全部', value: null }, { label: '在职/合作中', value: '0' }, { label: '离职/合作终止', value: '1' }]"
                :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="复诊价格">
            <el-select v-model="searchForm.revisitPriceFlag" clearable placeholder="复诊费用">
              <el-option label="未开启" value="2" />
              <el-option label="已开启" value="1" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getDoctorsList, true)">查询</el-button>
            <el-button icon="el-icon-refresh"
              @click="$reset(getDoctorsList, { doctorName: null, doctorTitle: null, status: null, revisitPriceFlag: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <!-- <el-button icon="el-icon-plus" type="primary" @click="addDoctor">新增馆外医生</el-button> -->
      </div>
      <!-- 医生列表 -->
      <el-table v-loading="loading" :data="doctorList" ref="multipleTable" :max-height="tableHeight"
        @selection-change="val => $handleSelectionChange(val, true)" border>
        <el-table-column prop="doctorName" label="姓名" />
        <el-table-column prop="sex" label="性别">
          <template slot-scope="scope">
            {{ scope.row.sex == '0' ? '男' : '女' }}
          </template>
        </el-table-column>
        <el-table-column prop="doctorTitle" label="职称" />
        <el-table-column prop="phone" label="电话" min-width="120" />
        <el-table-column prop="type" label="类型">
          <template slot-scope="scope">
            {{ scope.row.type == '0' ? '内部医生' : '外来医生' }}
          </template>
        </el-table-column>
        <el-table-column prop="appStatus" label="公众号查询">
          <template slot-scope="scope">
            {{ scope.row.appStatus == '0' ? '可查询' : '不可查询' }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.status == '0' ? '在职/合作中' : '离职/合作终止' }}
          </template>
        </el-table-column>
        <el-table-column prop="revisitPrice" label="复诊价格设置" min-width="160">
          <template slot-scope="scope">
            <div v-if="scope.row.revisitPrice && scope.row.revisitPrice.enabled === 1" class="revisitPrice_configured">
              <div>复诊周期：{{ scope.row.revisitPrice.revisitCycle }}天</div>
              <div v-if="scope.row.revisitPrice.enabledTypes.includes(0)">普通复诊号源：{{ scope.row.revisitPrice.revisitCommonPrice }}元</div>
              <div v-if="scope.row.revisitPrice.enabledTypes.includes(4)">理疗复诊号源：{{ scope.row.revisitPrice.revisitPhysioPrice }}元</div>
              <div v-if="scope.row.revisitPrice.enabledTypes.includes(2)">特约复诊号源：{{ scope.row.revisitPrice.revisitContributingPrice }}元</div>
            </div>
            <div v-else class="revisitPrice_not_configured">未配置</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button icon="el-icon-edit" type="primary" @click="editdoctor(scope.row)">编辑</el-button>
            <el-button :disabled="scope.row.status == '1'" icon="el-icon-delete" type="danger"
              @click="dimission(scope.row.doctorId)">停职</el-button>
            <el-button @click="openFollowupPriceDialog(scope.row)">{{ scope.row.revisitPrice && scope.row.revisitPrice.enabled === 1 ? '修改复诊价格' : '配置复诊价格' }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 新增或编辑弹框 -->
      <el-dialog class="doctorEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="760px"
        :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form label-width="110px" :model="editForm" ref="editForm" :rules="editFormRules" inline>
          <el-form-item label="医生姓名" prop="doctorName">
            <el-input v-model="editForm.doctorName" placeholder="请输入医生名称" />
          </el-form-item>
          <el-form-item label="医生编码" prop="doctorCode">
            <el-input v-model="editForm.doctorCode" placeholder="请输入医生编码" />
          </el-form-item>
          <el-form-item label="医生性别" prop="sex">
            <el-radio-group v-model="editForm.sex" :disabled="editForm.type == 0">
              <el-radio :label="'0'">男</el-radio>
              <el-radio :label="'1'">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="医生职称" prop="doctorTitle">
            <el-select v-model="editForm.doctorTitle" filterable default-first-option placeholder="请选择医生职称">
              <el-option v-for="item in doctorTitlesOptions" :key="item" :label="item" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="荣誉称号" prop="titleIds">
            <el-select v-model="editForm.titleIds" multiple filterable default-first-option placeholder="请选择荣誉称号">
              <el-option v-for="item in titlesOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="editForm.phone" placeholder="请输入电话号码" :disabled="editForm.type == 0" />
          </el-form-item>
          <el-form-item label="账号状态" prop="status">
            <el-radio-group v-model="editForm.status">
              <el-radio :label="'0'">在职/合作中</el-radio>
              <el-radio :label="'1'">离职/合作终止</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="坐诊科室" prop="postIds">
            <!-- <el-select v-model="editForm.postIds" multiple placeholder="请选择坐诊科室">
              <el-option v-for="item in postOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select> -->
            <div class="post_content">
              <el-tooltip effect="dark" :content="editForm.doctorPostInfos && editForm.doctorPostInfos.map(v => { return v.postName }).join('、')" placement="top">
                <div class="post_text">{{ editForm.doctorPostInfos && editForm.doctorPostInfos.map(v => { return v.postName }).join('、') }}</div>
              </el-tooltip>
              <el-button class="post_btn" type="primary" @click="openPostEdit">编辑科室</el-button>
            </div>
          </el-form-item>
          <el-form-item label="医生标签" prop="labelIds">
            <el-select v-model="editForm.labelIds" multiple placeholder="请选择医生标签">
              <el-option v-for="item in labelOptions" :key="item.labelId" :label="item.labelName"
                :value="item.labelId" />
            </el-select>
          </el-form-item>
            <el-form-item label="医生类型" prop="doctorType">
            <el-select v-model="editForm.doctorType" multiple placeholder="请选择医生标签" @change="doctorTypeChange">
              <el-option label="医生" :value="1" />
              <el-option label="理疗师" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="editForm.doctorType && (editForm.doctorType.includes(2) || editForm.doctorType.includes('2'))" label="是否公共外治" prop="sharePhysio">
            <el-radio-group v-model="editForm.sharePhysio">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <br/>
          <el-form-item label="公众查询" prop="appStatus">
            <el-radio-group v-model="editForm.appStatus">
              <el-radio :label="'0'">可查询</el-radio>
              <el-radio :label="'1'">不可查询</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="医生简介" prop="introduction">
            <el-input type="textarea" v-model="editForm.introduction" :autosize="{ minRows: 2, maxRows: 6 }"
              resize="none" />
          </el-form-item>
          <el-form-item label="擅长内容" prop="goodAt">
            <el-input type="textarea" v-model="editForm.goodAt" :autosize="{ minRows: 2, maxRows: 6 }" resize="none" />
          </el-form-item>

          <el-form-item label="执业照片" prop="doctorImgAddr">
            <div v-if="editForm.doctorImgAddr">
              <img :src="editForm.doctorImgAddr" class="img" />
              <el-button icon="el-icon-edit" type="primary" @click="editImg" class="btn">修改图片</el-button>
            </div>
            <el-upload v-else :on-success="handleImgSuccess" :action="uploadUrl" list-type="picture-card"
              :data="{ storagePath: 'picture' }" name="files">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="医生公告">
            <el-input type="textarea" v-model="editForm.notice" :autosize="{ minRows: 2, maxRows: 6 }" maxlength="100" resize="none" />
          </el-form-item>
          <el-form-item label="理疗公告">
            <el-input type="textarea" v-model="editForm.physioNotice" :autosize="{ minRows: 2, maxRows: 6 }" maxlength="100" resize="none" />
          </el-form-item>
          <div>
            <el-form-item label="叫号规则" prop="signinPolicy">
              <!-- <el-radio-group v-model="editForm.signinPolicy" @input="signinPolicyChange">
                <el-radio :label="'signin_date'">按签到顺序</el-radio>
                <el-radio :label="'default'">按预约顺序</el-radio>
              </el-radio-group> -->
              <el-select v-model="editForm.signinPolicy">
                <el-option v-for="item in policyOptions" :key="item.key" :label="item.value" :value="item.key" />
              </el-select>
            </el-form-item>
            <el-form-item v-if="editForm.signinPolicy && editForm.signinPolicy != 'signin_date'" label="保护位数"
              prop="signinParam">
              <el-select v-model="editForm.signinParam">
                <el-option v-for="item in protectionBits" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </div>
          <el-form-item label="资质">
            <el-select v-model="editForm.qualifications" multiple collapse-tags placeholder="请选择资质">
              <el-option v-for="item in qualificationList" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue" />
            </el-select>
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button v-if="dialogTitle == '编辑医生'" type="success" @click="editSave">保存编辑</el-button>
          <el-button v-if="dialogTitle == '新增馆外医生'" type="success" @click="addSave">保存新增</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getDoctorsList)" :total="total" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" />
      <el-dialog
        title="编辑科室"
        :visible.sync="postEditMap.visible"
        width="560px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="closePostEdit">
        <div class="postEdit_header">
          <div class="postEdit_btn_list">
            <el-button type="primary" @click="addPost()">增加科室</el-button>
          </div>
        </div>
        <div class="postEdit_table">
          <el-form ref="postEditForm" :model="postEditMap">
            <el-table
              :data="postEditMap.list"
              border
              max-height="300"
              style="width: 100%"
              row-key="vId">
              <el-table-column type="index" label="序号" width="50"></el-table-column>
              <el-table-column prop="postId" label="科室名称" min-width="220">
                <template slot-scope="scope">
                  <el-form-item class="post_form_item" :prop="`list[${scope.$index}].postId`" required :show-message="false">
                    <el-select v-model="scope.row.postId" placeholder="请选择" clearable @change="postSelect(scope.row)">
                      <el-option v-for="item in postOptions" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="sortNum" label="排序" min-width="120">
                <template slot-scope="scope">
                  <el-form-item class="post_form_item" :prop="`list[${scope.$index}].sortNum`" required :show-message="false">
                    <el-input v-model="scope.row.sortNum" @input="val => postEditMap.list[scope.$index].sortNum = val.replace(/\D/g, '')" placeholder="请输入" @blur="postSortBlur(scope.row)"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="danger" plain @click="delPost(scope.row.vId)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
        <div slot="footer">
          <el-button @click="closePostEdit">取 消</el-button>
          <el-button type="primary" @click="submitPostEdit">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 配置复诊价格弹窗 -->
      <el-dialog
        title="配置复诊价格"
        :visible.sync="followupPriceDialog.visible"
        width="560px"
        :close-on-click-modal="false"
        :before-close="closeFollowupPriceDialog">
        <el-form ref="followupPriceForm" :model="followupPriceForm" :rules="followupPriceRules" label-width="80px">
          <el-form-item label="配置开关" prop="enabled" required>
            <el-switch v-model="followupPriceForm.enabled" />
          </el-form-item>
          <el-form-item label="复诊周期" prop="period" :required="followupPriceForm.enabled">
            <div style="display: flex; align-items: center; flex-wrap: wrap;">
              <el-input
                v-model="followupPriceForm.period"
                placeholder="请输入"
                style="width: 120px;"
                maxlength="5"
                :disabled="!followupPriceForm.enabled"
                @input="val => followupPriceForm.period = val.replace(/\D/g, '')"
              />
              <span style="margin-left: 10px; color: #666;">天之内复诊的患者，享受复诊价格</span>
            </div>
          </el-form-item>
          <el-form-item label="复诊价格">
            <div class="followup-price-group">
              <div class="followup-price-item">
                <el-checkbox v-model="followupPriceForm.ordinaryChecked" :disabled="!followupPriceForm.enabled" @change="onFollowupTypeChange('ordinary')">普通</el-checkbox>
                <span v-if="followupPriceForm.ordinaryChecked" class="followup-price-label">复诊挂号费</span>
                <el-input
                  v-if="followupPriceForm.ordinaryChecked"
                  class="followup-price-input"
                  v-model="followupPriceForm.ordinaryPrice"
                  placeholder="请输入"
                  :disabled="!followupPriceForm.enabled"
                  @input="val => onFollowupPriceInput('ordinaryPrice', val)"
                  @blur="onFollowupPriceBlur('ordinaryPrice')"
                >
                  <template slot="append">元</template>
                </el-input>
              </div>
              <div class="followup-price-item">
                <el-checkbox v-model="followupPriceForm.physioChecked" :disabled="!followupPriceForm.enabled" @change="onFollowupTypeChange('physio')">理疗</el-checkbox>
                <span v-if="followupPriceForm.ordinaryChecked" class="followup-price-label">复诊挂号费</span>
                <el-input
                  v-if="followupPriceForm.physioChecked"
                  class="followup-price-input"
                  v-model="followupPriceForm.physioPrice"
                  placeholder="请输入"
                  :disabled="!followupPriceForm.enabled"
                  @input="val => onFollowupPriceInput('physioPrice', val)"
                  @blur="onFollowupPriceBlur('physioPrice')"
                >
                  <template slot="append">元</template>
                </el-input>
              </div>
              <div class="followup-price-item">
                <el-checkbox v-model="followupPriceForm.specialChecked" :disabled="!followupPriceForm.enabled" @change="onFollowupTypeChange('special')">特约</el-checkbox>
                <span v-if="followupPriceForm.ordinaryChecked" class="followup-price-label">复诊挂号费</span>
                <el-input
                  v-if="followupPriceForm.specialChecked"
                  class="followup-price-input"
                  v-model="followupPriceForm.specialPrice"
                  placeholder="请输入"
                  :disabled="!followupPriceForm.enabled"
                  @input="val => onFollowupPriceInput('specialPrice', val)"
                  @blur="onFollowupPriceBlur('specialPrice')"
                >
                  <template slot="append">元</template>
                </el-input>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="closeFollowupPriceDialog">取 消</el-button>
          <el-button type="primary" @click="submitFollowupPrice">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </Card>
</template>

<script lang="js">
import { doctorPage, doctorEdit, doctorInfo, doctorAdd, doctorDimission, getAllPolicy, getRevisitPriceConfig, saveRevisitPriceConfig } from "@/api/doctor"; // 医生请求
import { validateName, validatePhone } from "@/utils/regexp" // 自定义验证
import { doctorLabelList } from "@/api/doctorlabel"; // 标签列表请求
import { postList } from "@/api/post"; // 科室列表请求
import { titleList } from "@/api/title"; // 称号请求
import { userList } from "@/api/user"; // 用户请求
import { uploadTemporaryFile } from "@/api/post"; // 科室请求
import { isEmptyArray, isNull } from "@/utils/validateBase";
import req from '@/utils/request'

export default {
  name: "DoctorList",
  data() {
    return {
      loading: true, // 加载中
      searchForm: { doctorName: null, doctorTitle: null, status: null, revisitPriceFlag: null }, // 查询表单
      doctorList: [], // 医生列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      dialogVisible: false, // 编辑弹框状态
      dialogTitle: "", // 编辑框标题
      doctorOptions: [], // 医生选项
      editForm: {
        postIds: []
      }, // 编辑表单
      uploadUrl: this.$filePath + '/xl/upload/temp/file/upload', // 图片上传接口地址
      postOptions: [], // 坐诊科室列表
      labelOptions: [], // 医生标签列表
      doctorTitlesOptions: this.$doctorTitlesOptions, // 医生职称
      titlesOptions: [], // 荣誉称号
      editFormRules: {
        doctorName: [{ required: true, validator: validateName, trigger: "blur" }],
        // doctorCode: [{required: true, validator: validateName, trigger: "blur"}],
        phone: [{ required: true, validator: validatePhone, trigger: "blur" }],
        sex: [{ required: true, message: "医生性别不能为空！", trigger: "change" }],
        doctorTitle: [{ required: true, message: "医生职称不能为空！", trigger: "change" }],
        status: [{ required: true, message: "医生状态不能为空！", trigger: "change" }],
        introduction: [{ required: true, message: "医生简介不能为空！", trigger: "blur" }],
        goodAt: [{ required: true, message: "医生擅长不能为空！", trigger: "blur" }],
        doctorImgAddr: [{ required: true, message: "医生执业照片不能为空！" }],
        signinPolicy: [{ required: true, message: "叫号规则不能为空！" }],
        signinParam: [{ required: true, message: "预约叫号规则不能为空！" }],
        doctorType: [{ required: true, message: "医生类型不能为空！" }],
        sharePhysio: [{ required: true, message: "请选择是否公共外治！" }]
      }, // 验证规则
      followupHelpersOptions: [], // 医助列表
      tableHeight: 0, // 表格最大高度
      deptId: this.$session.get('deptId'),
      fileList: [],
      protectionBits: [
        { label: '不保护', value: '0' },
        { label: '保护3位', value: '3' },
        { label: '保护5位', value: '5' },
      ],
      policyOptions: [],
      qualificationList: [],
      postEditMap: {
        visible: false,
        list: []
      },
      // 配置复诊价格
      followupPriceDialog: {
        visible: false,
        currentDoctor: null,
        currentConfigId: null
      },
      followupPriceForm: {
        enabled: false,
        period: '',
        ordinaryChecked: false,
        ordinaryPrice: '',
        physioChecked: false,
        physioPrice: '',
        specialChecked: false,
        specialPrice: ''
      },
      followupPriceRules: {
        period: [
          { validator: (rule, value, callback) => {
            if (!this.followupPriceForm.enabled) {
              callback();
              return;
            }
            if (value === '' || value === null || value === undefined) {
              callback(new Error('复诊周期不能为空'));
              return;
            }
            const num = parseInt(value, 10);
            if (isNaN(num) || num < 0 || num !== parseFloat(value)) {
              callback(new Error('请输入0或正整数'));
              return;
            }
            if (String(num).length > 5) {
              callback(new Error('复诊周期最多5位数字'));
              return;
            }
            callback();
          }, message: '复诊周期不能为空', trigger: ['blur', 'change']}
        ]
      }
    };
  },
  created() {
    if (document.documentElement.clientWidth > 1250) {
      this.tableHeight = document.documentElement.clientHeight - 330
    } else {
      this.tableHeight = document.documentElement.clientHeight - 370
    }
    this.getDoctorsList();// 获取医生列表
    this.getPostList(); // 请求科室列表
    this.getDoctorLabelList(); // 请求标签列表
    this.getTitlesData(); // 请求称号列表
    this.getUsersList(); // 请求医助列表
    this.$getDoctorOptions(); // 获取所有医生
    this.getQualificationList()
  },
  methods: {
    async getQualificationList() {
      const res = await req.get('/system/dict/data/type/DOCTOR_QUALIFICATIONS')
      if (res.code == 200) {
        this.qualificationList = res.data
      }
    },
    // 请求医生列表
    async getDoctorsList() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let res = await doctorPage(params);
      let { code } = res;
      if (code == 200) {
        this.total = res.total != null ? res.total : (res.data && res.data.total != null ? res.data.total : 0);
        const rows = res.rows || res.records || (res.data && (res.data.records || res.data.rows));
        this.doctorList = rows || [];
      }
      this.loading = false;
    },
    // 请求医助列表
    async getUsersList() {
      let { total, rows, code } = await userList({ type: 1 });
      if (code == 200) {
        if (total > 0) {
          rows.forEach(item => {
            if (item.type == '1') {
              this.followupHelpersOptions.push({ nickName: item.nickName, userId: item.userId, helperType: 20, userCode: item.userCode });
            }
          });
        };
      }
    },
    // 请求称号列表
    async getTitlesData() {
      let { total, rows, code } = await titleList();
      if (total > 0 && code == 200) rows.forEach(item => { this.titlesOptions.push({ label: item.titleName, value: item.titleId }) })
    },
    doctorTypeChange (values) {
      if (values.includes(2) || values.includes('2')) {
        this.editForm.sharePhysio = 1
      } else {
        this.editForm.sharePhysio = 0
      }
    },
    // 新增馆外医生
    addDoctor() {
      this.dialogVisible = true;
      this.fileList = []
      this.dialogTitle = "新增馆外医生";
      this.editForm = {
        doctorName: null,
        appStatus: '1',
        status: '0',
        sex: '0',
        phone: null,
        goodAt: null,
        introduction: null,
        doctorType:[],
        sharePhysio: 0,
        doctorTitle: null,
        doctorImgAddr: null,
        titleIds: [],
        type: 1,
        assistantName: null,
        deptId: this.deptId,
        signinPolicy: 'default',
        signinParam: '3',
        notice:null,
        physioNotice:null
      };
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate(async (valid) => {
        if (valid) {
          let obj = []
          this.fileList.forEach(v => {
            obj.push({ uploadChannel: "doctorImgAddr", fileId: v.fileId, groupName: "group1", isNeedThumbnail: "2" })
          })
          let res = await uploadTemporaryFile(obj)
          if (res.errorCode == '0000') {
            this.editForm.doctorImgAddr = res.data[0].fullPathUrl
            doctorAdd(this.editForm).then(res => {
              let { code } = res;
              if (code == 200) this.$message.success("新增馆外医生成功！");
              this.dialogVisible = false;
              this.$refresh(this.getDoctorsList);
              this.$refs['editForm'].resetFields();
            });
          } else {
            this.$message.error(res.errorMessage)
          }

        } else return false;
      })
    },
    // 编辑医生信息
    async editdoctor(row) {
      this.getAllPolicy()
      let { data, code } = await doctorInfo(row.doctorId);
      if (code == 200) {
        let labelIds = [], postIds = [];
        if (data.labels && data.labels.length > 0) data.labels.forEach(item => { labelIds.push(item.doctorLabelId) });
        if (data.sysPosts && data.sysPosts.length > 0) data.sysPosts.forEach(item => { postIds.push(item.postId) });
        data.labelIds = labelIds, data.postIds = postIds;
        data.doctorPostInfos && data.doctorPostInfos.map(v => {
          const post = this.postOptions.find(p => p.value === v.postId)
          v['postName'] = post ? post.label : ''
        })
        this.editForm = data;
        this.editForm.deptId = this.deptId;
        this.dialogTitle = "编辑医生";
        this.dialogVisible = true;
        if (data.doctorImgAddr) {
          this.fileList = [{ name: data.doctorImgAddr, url: data.doctorImgAddr }]
        }
      }
    },
    // 保存医生修改
    async editSave() {
      this.$refs['editForm'].validate(async (valid) => {
        if (valid) {
          let obj = []
          this.fileList.forEach(v => {
            if (!isNull(v.fileId)) {
              obj.push({ uploadChannel: "doctorImgAddr", fileId: v.fileId, groupName: "group1", isNeedThumbnail: "2" })
            }
          })
          if (isEmptyArray(obj)) {
            delete this.editForm.isExam
            delete this.editForm.followupHelpers
            delete this.editForm.dailyHelpers
            doctorEdit(this.editForm).then(res => {
              let { code } = res;
              if (code == 200) this.$message.success("修改医生信息成功！");
              this.dialogVisible = false;
              this.$refresh(this.getDoctorsList);
              this.$refs['editForm'].resetFields();
            });
          } else {
            let res = await uploadTemporaryFile(obj)
            if (res.errorCode == '0000') {
              this.editForm.doctorImgAddr = res.data[0].fullPathUrl
              doctorEdit(this.editForm).then(res => {
                let { code } = res;
                if (code == 200) this.$message.success("修改医生信息成功！");
                this.dialogVisible = false;
                this.$refresh(this.getDoctorsList);
                this.$refs['editForm'].resetFields();
              });
            } else {
              this.$message.error(res.errorMessage)
            }
          }
        } else return false;
      })
    },
    // 医生停职
    dimission(doctorId) {
      this.$confirm('确认停职该医生？停职后将不能登录系统，所有排班将停诊！').then(_ => {
        doctorDimission(doctorId).then(res => {
          if (res.code == 200) {
            this.$message.success('该医生停职成功，排班已停诊、系统账号已不能登录！');
            this.$refresh(this.getDoctorsList);
          }
        })
      }).catch(_ => { });
    },
    // 获取科室列表
    async getPostList() {
      let { total, rows, code } = await postList();
      if (total > 0 && code == 200) rows.forEach(item => { this.postOptions.push({ label: item.postName, value: item.postId }) });
    },
    // 获取标签列表
    async getDoctorLabelList() {
      let { total, rows, code } = await doctorLabelList({ type: 0 });
      if (total > 0 && code == 200) rows.forEach(item => { this.labelOptions.push({ labelName: item.name, labelId: item.doctorLabelId }) });
    },
    // 图片上传成功的函数
    handleImgSuccess(res, file, fileList) {
      console.log(88888888, res, file, fileList);
      if (res.errorCode == '0000') {
        this.editForm.doctorImgAddr = file.url;
        this.fileList.push(res.data[0])
      }
    },
    // 清除图片地址，显示上传图片
    editImg() {
      this.editForm.doctorImgAddr = null;
      this.fileList = []
    },
    //叫号规则改变
    signinPolicyChange(val) {
      if (val == 'default') {
        this.editForm.signinParam = '3'
      } else {
        this.editForm.signinParam = '3'
      }
    },
    async getAllPolicy() {
      let { code, data } = await getAllPolicy()
      if (code == 200) {
        this.policyOptions = data
      }
    },
    generateUUID () {
      return 'xxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0
        const v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    openPostEdit () {
      this.postEditMap.visible = true
      const list = (this.editForm.doctorPostInfos && JSON.parse(JSON.stringify(this.editForm.doctorPostInfos))) || []
      this.postEditMap.list = list.map(v => {
        const post = this.postOptions.find(p => p.value === v.postId)
        v['vId'] = this.generateUUID()
        v['postName'] = post ? post.label : ''
        return v
      })
    },
    closePostEdit () {
      this.postEditMap.visible = false
      this.postEditMap.list = []
    },
    addPost () {
      this.postEditMap.list.unshift({
        vId: this.generateUUID(),
        postId: '',
        postName: '',
        sortNum: ''
      })
    },
    delPost (vId) {
      this.$confirm('确认删除该科室?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const index = this.postEditMap.list.findIndex(v => v.vId === vId)
        if (index > -1) {
          this.postEditMap.list.splice(index, 1)
        }
      }).catch(() => {})
    },
    postSelect (row) {
      const has = this.postEditMap.list.some(v => v.vId !== row.vId && v.postId === row.postId)
      if (has) {
        this.$message.error('此科室已存在')
        row.postId = ''
        row.postName = ''
      } else {
        const post = this.postOptions.find(v => v.value === row.postId)
        if (post) {
          row.postName = post.label
        }
      }
    },
    postSortBlur (row) {
      let list = JSON.parse(JSON.stringify(this.postEditMap.list))
      list.sort((a, b) => {
        return Number(a.sortNum) - Number(b.sortNum)
      })
      this.postEditMap.list = list
      
      this.$nextTick(() => {
        const newIndex = this.postEditMap.list.findIndex(v => v.vId === row.vId)
        this.$refs['postEditForm'].validateField(`list[${newIndex}].sortNum`)
      })
    },
    submitPostEdit () {
      this.$refs['postEditForm'].validate(valid => {
        if (valid) {
          this.editForm.doctorPostInfos = JSON.parse(JSON.stringify(this.postEditMap.list))
          this.closePostEdit()
        }
      })
    },
    // 打开配置复诊价格弹窗
    async openFollowupPriceDialog (row) {
      this.followupPriceDialog.currentDoctor = row;
      this.followupPriceForm = {
        enabled: false,
        period: '',
        ordinaryChecked: false,
        ordinaryPrice: '',
        physioChecked: false,
        physioPrice: '',
        specialChecked: false,
        specialPrice: ''
      };
      this.followupPriceDialog.visible = true;
      this.$nextTick(() => {
        this.$refs.followupPriceForm && this.$refs.followupPriceForm.clearValidate();
      });
      const { code, data } = await getRevisitPriceConfig(row.doctorId);
      if (code === 200 && data) {
        this.followupPriceDialog.currentConfigId = data.id || null;
        this.followupPriceForm.enabled = data.enabled === 1;
        this.followupPriceForm.period = data.revisitCycle != null ? String(data.revisitCycle) : '';
        const types = data.enabledTypes || [];
        this.followupPriceForm.ordinaryChecked = types.includes(0);
        this.followupPriceForm.ordinaryPrice = this.followupPriceForm.ordinaryChecked && data.revisitCommonPrice != null ? String(data.revisitCommonPrice) : '';
        this.followupPriceForm.physioChecked = types.includes(4);
        this.followupPriceForm.physioPrice = this.followupPriceForm.physioChecked && data.revisitPhysioPrice != null ? String(data.revisitPhysioPrice) : '';
        this.followupPriceForm.specialChecked = types.includes(2);
        this.followupPriceForm.specialPrice = this.followupPriceForm.specialChecked && data.revisitContributingPrice != null ? String(data.revisitContributingPrice) : '';
      }
    },
    // 关闭配置复诊价格弹窗
    closeFollowupPriceDialog () {
      this.followupPriceDialog.visible = false;
      this.followupPriceDialog.currentDoctor = null;
      this.followupPriceDialog.currentConfigId = null;
      this.$refs.followupPriceForm && this.$refs.followupPriceForm.resetFields();
    },
    // 复诊价格输入：仅允许数字与一个小数点，小数部分最多 2 位
    onFollowupPriceInput (field, val) {
      this.followupPriceForm[field] = this.formatPriceInput(val);
    },
    formatPriceInput (val) {
      let s = String(val || '').replace(/[^\d.]/g, '');
      if (s === '') return '';
      const dotPos = s.indexOf('.');
      if (dotPos === -1) return s;
      const head = s.slice(0, dotPos + 1);
      const tail = s.slice(dotPos + 1).replace(/\./g, '').slice(0, 2);
      return head + tail;
    },
    onFollowupTypeChange (type) {
      if (type === 'ordinary' && !this.followupPriceForm.ordinaryChecked) {
        this.followupPriceForm.ordinaryPrice = '';
      }
      if (type === 'physio' && !this.followupPriceForm.physioChecked) {
        this.followupPriceForm.physioPrice = '';
      }
      if (type === 'special' && !this.followupPriceForm.specialChecked) {
        this.followupPriceForm.specialPrice = '';
      }
    },
    // 失焦：最多保留两位小数，并去掉末尾多余 0（负数按 0 处理）
    onFollowupPriceBlur (field) {
      const v = this.followupPriceForm[field];
      if (v === '' || v === null || v === undefined) return;
      const n = parseFloat(v);
      if (isNaN(n)) {
        this.followupPriceForm[field] = '';
        return;
      }
      this.followupPriceForm[field] = Number(Math.max(0, n).toFixed(2));
    },
    // 校验价格：数字、最多2位小数、可为0、不能为负
    validatePrice (value) {
      if (value === '' || value === null || value === undefined) return '请输入价格';
      const num = parseFloat(value);
      if (isNaN(num)) return '请输入有效数字';
      if (num < 0) return '价格不能为负数';
      if (/\.\d{3,}$/.test(String(value))) return '最多允许2位小数';
      return true;
    },
    // 提交配置复诊价格
    async submitFollowupPrice () {
      const { ordinaryChecked, ordinaryPrice, physioChecked, physioPrice, specialChecked, specialPrice } = this.followupPriceForm;
      if (ordinaryChecked) {
        const err = this.validatePrice(ordinaryPrice);
        if (err !== true) {
          this.$message.error('普通价格：' + err);
          return;
        }
      }
      if (physioChecked) {
        const err = this.validatePrice(physioPrice);
        if (err !== true) {
          this.$message.error('理疗价格：' + err);
          return;
        }
      }
      if (specialChecked) {
        const err = this.validatePrice(specialPrice);
        if (err !== true) {
          this.$message.error('特约价格：' + err);
          return;
        }
      }
      this.$refs.followupPriceForm.validate(async valid => {
        if (!valid) return;
        const enabledTypes = [];
        if (ordinaryChecked) enabledTypes.push(0);
        if (physioChecked) enabledTypes.push(4);
        if (specialChecked) enabledTypes.push(2);
        if (this.followupPriceForm.enabled && enabledTypes.length === 0) {
          this.$message.error('请至少选择一种复诊价格');
          return;
        }
        const payload = {
          id: this.followupPriceDialog.currentConfigId || undefined,
          doctorId: this.followupPriceDialog.currentDoctor.doctorId,
          doctorName: this.followupPriceDialog.currentDoctor.doctorName,
          enabled: this.followupPriceForm.enabled ? 1 : 0,
          enabledTypes,
          revisitCycle: Number(this.followupPriceForm.period || 0),
          revisitCommonPrice: ordinaryChecked ? Number(ordinaryPrice) : undefined,
          revisitPhysioPrice: physioChecked ? Number(physioPrice) : undefined,
          revisitContributingPrice: specialChecked ? Number(specialPrice) : undefined
        };
        const { code } = await saveRevisitPriceConfig(payload);
        if (code === 200) {
          this.$message.success('保存成功');
          this.closeFollowupPriceDialog();
          this.$refresh(this.getDoctorsList);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.doctorwrap {
  &>div:not(:last-child) {
    margin-bottom: 20px;
  }

  .doctorEdit {
    .el-form-item {
      width: 50%;
      margin-right: 0;
    }

    /deep/.el-input,
    /deep/.el-textarea {
      width: 240px;
    }
  }

  .img {
    width: 240px;
    border: 1px solid #e6e6e6;
    height: auto;
    display: block;
  }

  .btn {
    margin-top: 5px;
  }
}

.revisitPrice_configured div {
  line-height: 20px;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}

.revisitPrice_not_configured {
  line-height: 20px;
  font-weight: 400;
  font-size: 14px;
  color: #A4AFBA;
}

.post_content {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 240px;
}

.post_text {
  flex-grow: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.post_btn {
  margin: 0 0 0 10px;
}

.postEdit_table{
  margin: 10px 0 0 0;
}

.post_form_item {
  margin: 0 0 0 0;
}

.followup-price-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.followup-price-item {
  display: flex;
  align-items: center;
}

.followup-price-label {
  margin: 0 0 0 24px;
  font-size: 14px;
  color: #667182;
}

.followup-price-input {
  position: relative;
  z-index: 1;
  margin: 0 0 0 12px;
  width: 160px;
}

.followup-price-input /deep/ .el-input__inner {
  padding: 0 30px 0 15px;
}

.followup-price-input /deep/ .el-input-group__append {
  box-sizing: border-box;
  position: absolute;
  z-index: 2;
  top: 1px;
  right: 1px;
  padding: 0px;
  width: 30px;
  height: 30px;
  line-height: 28px;
  text-align: center;
  border: none;
  background-color: #FFFFFF;
}

</style>